// Put your application javascript here
window.addEventListener("load", application, false);
function application() {

  let scrollDelta = 0;
  const threshold = 50;
  let lastScrollY = window.scrollY;
  
  const headerSticky = document.querySelector('.header-c');

  // document.querySelector('.toggler').onclick = function (){ 
  //   toggleHeaderMenu();
  //   popupBodyOn();
  // };
  // document.querySelector('.wedding-toggler').onclick = function (){ 
  //   this.classList.remove('active');
  //   document.querySelector('.wedding-m-menu').classList.add('active');
  // };
  // document.querySelector('.nav-m-close').onclick = function (){ 
  //   toggleHeaderMenu();
  //   popupBodyOff(); 
  //   document.querySelector('.wedding-toggler').classList.add('active');
  //   document.querySelector('.wedding-m-menu').classList.remove('active');
  // };
  // function toggleHeaderMenu() {
  //   document.querySelector('.nav-m').classList.toggle("active");
  // }
  

  const dropdownItems = document.querySelectorAll('.dropdown-item');

  // dropdownItems.forEach(function(item) {
  //   item.onclick = function() {
  //     if (this.closest('.dropdown-item').classList.contains("active")) {
  //       this.closest('.dropdown-item').classList.remove("active");
  //       document.querySelector('body').classList.remove("is-dropdown");
  //     } else {
  //       document.querySelectorAll('.dropdown-item').forEach(function(item) {
  //         item.classList.remove("active");
  //       });
  //       this.closest('.dropdown-item').classList.add("active");
  //       document.querySelector('body').classList.add("is-dropdown");
  //     }
  //   };
  // });
 
  dropdownItems.forEach(function(item) {
    item.onmouseover = function() {
        // Remove 'active' class from all items and 'is-dropdown' class from body
        document.querySelectorAll('.dropdown-item').forEach(function(item) {
            item.classList.remove("active");
        });
        document.querySelector('body').classList.add("is-dropdown");

        // Add 'active' class to the current item
        this.closest('.dropdown-item').classList.add("active");
    };

    item.onmouseout = function() {
        // Remove 'active' class from the current item
        this.closest('.dropdown-item').classList.remove("active");

        // Check if any dropdown item is still active
        let anyActive = Array.from(document.querySelectorAll('.dropdown-item')).some(item => item.classList.contains("active"));
        
        // Remove 'is-dropdown' class from body if no item is active
        if (!anyActive) {
            document.querySelector('body').classList.remove("is-dropdown");
        }
    };
  });
  
  document.querySelector('.dropdown-overlay').onclick = function (){
    document.querySelectorAll('.dropdown-item').forEach(function(item) {
      item.classList.remove("active");
    });
    document.querySelector('body').classList.remove("is-dropdown");
  };
  
  // document.querySelector('.nav-m-search .search-toggler').onclick = function (){ 
  //   toggleSearch();
  //   document.querySelector('.nav-m').classList.remove("active");
  // };
  // document.querySelector('.nav-item--search').onclick = function (){ 
  //   toggleSearch();
  // };
  // document.querySelector('.nav-search-close').onclick = function (){ 
  //   toggleSearch();
  //   if (!document.querySelector('.nav-m').classList.contains('active')) {
  //     popupBodyOff();
  //   }
  // };
  
  // function toggleSearch() {
  //   document.querySelector('.nav-search-block').classList.toggle("active");
  // }

  document.querySelectorAll('.nav-footer-h').forEach(item => {
    item.addEventListener('click', event => {
      const itemStatus = item.parentNode.classList.contains("active");
      [...item.parentElement.parentElement.children].forEach(sib => sib.classList.remove('active'));
      if(!itemStatus) {
        item.parentNode.classList.add("active");
      }
    });
  });




  // function toggleCart() {
  //   document.querySelector('.popup-cart').classList.toggle("active");
  // }

  // SlideIn About text
  const slideObjects = document.querySelectorAll('.js-slidein');
  slideObjects.forEach((el, i) => {
    console.log('el: ' + el);
    const bottomObject = el.getBoundingClientRect().top;
    const bottomWindow = window.scrollY + window.innerHeight;

    if (bottomWindow > bottomObject) {
      el.classList.remove('js-slidein');
    }

    console.log('Obj: ' + bottomObject + ', Win: ' + bottomWindow);
  });
  
  window.addEventListener('scroll', function() {
    const slideObjects = document.querySelectorAll('.js-slidein');
    slideObjects.forEach((el, i) => {    
      const bottomObject = el.getBoundingClientRect().top + el.clientHeight / 2;
      const bottomWindow = window.scrollY + window.innerHeight;

      if (bottomWindow > bottomObject) {
        el.classList.add('js-slidein-visible');
      }

      // console.log('ObjScroll: ' + bottomObject + ', WinScroll: ' + bottomWindow);
    });
  });

  if (document.querySelector('.tip') !== null) {
    document.querySelectorAll('.tip').forEach(infotip => {
      tippy(infotip, {
        content(reference) {
          const template = reference.nextElementSibling;
          return template.innerHTML;
        },
        allowHTML: true,
        trigger: 'click',
        interactive: true,
      });
    });
  }

  window.addEventListener("scroll", function(event) {
    if (window.joolmeMobileScrollReady && window.innerWidth < 992) return;
    // sticky header 
    const top = this.scrollY;
    if (document.querySelector('body').classList.contains('product-page') || document.querySelector('body').classList.contains('tablet-page')) {
      if(top > 0) {
        document.querySelector('body').classList.add('scrolled');
      } else {
        document.querySelector('body').classList.remove('scrolled');
      }
    } else {
      if(top > 42) {
        document.querySelector('body').classList.add('scrolled');
      } else {
        document.querySelector('body').classList.remove('scrolled');
      }
    }

    const diff = top - lastScrollY;

    if (Math.abs(diff) > 5) {
      scrollDelta += diff;
  
      if (scrollDelta > threshold && top > 42) {
        headerSticky.classList.remove('show');
        scrollDelta = 0;
      }
  
      if (scrollDelta < -threshold) {
        headerSticky.classList.add('show');
        scrollDelta = 0;
      }
    }

    lastScrollY = top;
    
    // sticky addtocart 
    if (document.querySelector('.section-product') !== null) {
      let btnTop = 0;
      if (document.getElementById('chooseSettingBtn') !== null) {
        btnTop = document.getElementById('chooseSettingBtn').getBoundingClientRect().top;
      } else if (document.getElementById('addtocartbtn') !== null) {
        btnTop = document.getElementById('addtocartbtn').getBoundingClientRect().top;
      }
      if(btnTop < 0) {
        document.querySelector('.btns-m-sticky').classList.add('visible');
      } else {
        document.querySelector('.btns-m-sticky').classList.remove('visible');
      }
    }
  }, false);

  // Shopify Inbox Chat
  function initChatToggler() {
    const chatTogglers = document.querySelectorAll(".chat-toggler");
    // chatTogglers.forEach(toggler => toggler.addEventListener("click", () => {
    //   console.log('listenChatToggler');
    //     toggleChat();
    // }));    
    chatTogglers.forEach(addClickListenerToToggler);
  };
  function getChatIFrame() {
    return document.getElementById('ShopifyChat') || document.getElementById('dummy-chat-button-iframe') || null;
  }
  function toggleChat() {
    let firstTimeChat = true;
    const chatIFrame = getChatIFrame();
    if (document.getElementById('ShopifyChat')) {
      firstTimeChat = false;
    }
    // document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
      setTimeout(function () {
          chatIFrame.classList.add('active');
          if (chatIFrame.shadowRoot.querySelector('.chat-toggle')) {
            chatIFrame.shadowRoot.querySelector('.chat-toggle').click();
          }
          if (firstTimeChat) {
            setTimeout(function () {
              if (document.getElementById('ShopifyChat')) {
                document.getElementById('ShopifyChat').classList.add('active');
                if (document.getElementById('ShopifyChat').shadowRoot.querySelector('.chat-toggle')) {
                  document.getElementById('ShopifyChat').shadowRoot.querySelector('.chat-toggle').click();
                  // setTimeout(function () {
                  //   chatIFrame.addEventListener('load', chatFrameListener(chatIFrame));
                  // }, 500);
                }
              }
            }, 500);
          }
      }, 300);
    
      setTimeout(function () {
        // Chat close 

        const chatIFrameUpdated = document.getElementById('ShopifyChat') || document.getElementById('dummy-chat-button-iframe') || null;
        chatIFrameUpdated.addEventListener('load', chatFrameListener(chatIFrameUpdated));
       
      }, 1000);
        
   
      return false;
  };

  function addClickListenerToToggler(toggler) {
    toggler.classList.add("visible");
    toggler.addEventListener("click", () => {
      toggleChat();
    });
  }

  function chatFrameListener(frame) {
    const chatWindow = frame.contentWindow;
    if (chatWindow) {
      const closeButton = chatWindow.document.querySelector('.chat-app--close-button');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          frame.classList.remove('active');
        });
      } else {
        setTimeout(function () {
          const closeButton2 = chatWindow.document.querySelector('.chat-app--close-button');
          if (closeButton2) {
            closeButton2.addEventListener('click', function() {
              frame.classList.remove('active');
            });
          }
        }, 3000);
      }
    }
  }
  
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const shopifyChatDiv1 = document.getElementById("shopify-chat");
        const shopifyChatDiv2 = document.getElementById("dummy-chat-button-iframe");
        if (shopifyChatDiv1 || shopifyChatDiv2) {
          initChatToggler();
          const newTogglers = mutation.addedNodes;
          newTogglers.forEach((node) => {
            if (node.classList && node.classList.contains("chat-toggler")) {
              addClickListenerToToggler(node);
            }
          });
          // observer.disconnect();
          break;
        }
      }
    }
  });

  // Start observing changes in the DOM
  observer.observe(document.documentElement, { childList: true, subtree: true });
  
  
  

  // description More link
  const descs = document.querySelectorAll('.product-description');
  [...descs].forEach(desc => {
    let descH = desc.offsetHeight;
    let descLineH;
    if (desc.closest('.product-desc') !== null) {
      descLineH = 35; // desktop
    } else {
      descLineH = 21; // mobile
    }

    if (descH > descLineH * 2) {
      desc.classList.add('collapsed');
      desc.insertAdjacentHTML("beforeend", '<span class="more"><span class="ellipsis">...</span> <span class="txt">קרא עוד</span></span>');
      setTimeout(function () {
        desc.querySelector('.more').onclick = function (){ 
          this.parentNode.classList.add("expanded");
          this.parentNode.classList.remove('collapsed');
        };
      }, 100);
    } else {
      desc.classList.add('expanded');
    }
  
  });



  
  // appointment - virtual
  // const virtualVideo = document.getElementById('virtualVideo');
  // console.log('VIRTUAL', virtualVideo);
  // if (virtualVideo.length !== null) {
  //   console.log('VIRTUAL2', virtualVideo.src);
  //   let mobileSrc = "https://cdn.shopify.com/videos/c/o/v/adc6195bbff8425fbdf335230b227a23.mov";
  //   let desktopSrc = "https://cdn.shopify.com/videos/c/o/v/0b05de9374df4b3ca4f2c53a7d90a828.mp4";
     
  //   if ($(window).width() < 992) {
  //        virtualVideo.src = mobileSrc;
  //   } else {
  //        virtualVideo.src = desktopSrc;
  //   }
  //   virtualVideo.className.add('active');
  // }

  // free filter
  if (document.querySelector('.free-filter') !== null) {
    // const activeFreeEl = document.querySelector('.free-filter .active');
    // if (activeFreeEl) {
      // activeFreeEl.scrollIntoView();
    // }
    var activeElement = document.querySelector('.free-filter .active');
    if (activeElement) {
      var parentElement = activeElement.parentElement;
      while (parentElement && parentElement !== document && parentElement.className !== 'free-filter') {
        parentElement = parentElement.parentElement;
      }
      if (parentElement) {
        var scrollLeft = activeElement.offsetLeft - parentElement.offsetLeft;
        var firstElement = document.querySelector('.free-filter li:first-child a');
        var lastElement = document.querySelector('.free-filter li:last-child a');
        if (activeElement === firstElement) {
          scrollLeft -= 16;
        } else if (activeElement === lastElement) {
          scrollLeft -= 16;
        } else {
          scrollLeft -= 8;
        }
        parentElement.scrollLeft = scrollLeft;
      }
    }
    // setTimeout(function () {
    //   document.querySelector('.free-filter').classList.add('visible');
    // }, 200);
  }


  /* wrap collection text */
    const collectionText = document.getElementById("collection-text");
    if (collectionText) {
      let wrapper = document.createElement('div');
      wrapper.classList.add('text-block');
      Array.from(collectionText.children).forEach(child => {
          if (child.tagName === 'H2') {
              if (wrapper.childElementCount > 0) {
                  collectionText.appendChild(wrapper);
                  wrapper = document.createElement('div');
                  wrapper.classList.add('text-block');
              }
          }
          wrapper.appendChild(child);
      });
      if (wrapper.childElementCount > 0) {
          collectionText.appendChild(wrapper);
      }
      document.querySelectorAll('.text-block').forEach((textBlock, index, array) => {
          const contentWrapper = document.createElement('div');
          contentWrapper.classList.add('block-body');
          Array.from(textBlock.children).forEach(child => {
              if (child.tagName !== 'H2') {
                  contentWrapper.appendChild(child);
              }
          });
          textBlock.appendChild(contentWrapper);
          if (index === array.length - 1) {
              textBlock.classList.add('is-active');
          }
      });
      const h2Elements = document.querySelectorAll('.text-block h2');
  
  
      h2Elements.forEach(h2 => {
          h2.addEventListener('click', function(event){
            const clickedH2 = event.target;
            const textBlock = clickedH2.closest('.text-block');
            const siblings = Array.from(textBlock.parentElement.children);
            
            // siblings.forEach(sibling => {
            //     if (sibling !== textBlock) {
            //         sibling.classList.remove('is-active');
            //     }
            // });
            textBlock.classList.toggle('is-active');
            const scrollH2 = window.innerWidth < 992 ? 50 : 20;
            window.scrollTo({
              top: event.currentTarget.offsetTop - scrollH2,
              behavior: 'smooth'
            });
          });
      });

      
  
      const productListBottom = document.querySelector('.product-list-bottom');
      if (productListBottom) {
          productListBottom.classList.add('is-ready');
      }

      // // collection bottom read more
      // const colldesc = document.querySelectorAll('.section-collection-desc .text');
      // [...colldesc].forEach(desc => {
      //   let descH = desc.offsetHeight;
      //   let descLineH = 21;
    
      //   if (descH > descLineH * 2) {
      //     desc.classList.add('collapsed');
      //     desc.insertAdjacentHTML("beforeend", '<span class="more"><span class="ellipsis">...</span> <span class="txt">קרא עוד</span></span>');
      //     setTimeout(function () {
      //       desc.querySelector('.more').onclick = function (){ 
      //         this.parentNode.classList.add("expanded");
      //         this.parentNode.classList.remove('collapsed');
      //       };
      //     }, 100);
      //   } else {
      //     desc.classList.add('expanded');
      //   }
      
      // });       
      
    }

    const colldesc = document.querySelectorAll('.section-collection-desc .text');
    if (colldesc) {
      colldesc.forEach(desc => {
        let descH = desc.offsetHeight;
        let descLineH = 21;
      
        if (descH > descLineH * 2) {
          desc.classList.add('collapsed');
      
          const toggleExpandCollapse = (event) => {
            if (desc.classList.contains('collapsed')) {
              desc.classList.remove('collapsed');
              desc.classList.add('expanded');
            } else {
              desc.classList.remove('expanded');
              desc.classList.add('collapsed');
            }
          };
      
          setTimeout(() => {
            desc.querySelector('.more').onclick = toggleExpandCollapse;
            desc.querySelector('.less').onclick = toggleExpandCollapse;
          }, 100);
        } else {
          desc.classList.add('expanded');
        }
      }); 
    }

    const collectionFAQ = document.querySelector(".collection-faq");
    if (collectionFAQ) {
      document.querySelectorAll('.faq-item .faq-q').forEach(item => {
        item.addEventListener('click', event => {
            const parent = item.parentNode;    
            Array.from(parent.parentNode.children).forEach(sibling => {
                if (sibling !== parent) {
                    sibling.classList.remove("active");
                }
            });
            parent.classList.toggle("active");
        });
      });
    }
    
  /* end of wrap */

  document.querySelectorAll('.slink').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('href').substring(1);

      window.scrollTo({
        top: document.getElementById(targetId).offsetTop,
        behavior: 'smooth'
      });
    });
  });

  const cookieBanner = document.querySelector('.cookie-banner');

  if (cookieBanner) {
      const isShowCookie = getCookie('isShowCookie');
      
      if (isShowCookie) {
          grantTrackingConsent();
          cookieBanner.remove();
      } else {
          cookieBanner.classList.remove('d-none');
          
          setTimeout(function() {
              grantTrackingConsent();
              cookieBanner.remove();
              setCookie('isShowCookie', 'true');
          }, 3000);
      }
  }
}

// function onSubscribeFormSubmit(token) {
function onSubscribeFormSubmit() {
  // Get the form data
  const formData = new FormData(subscribeForm);
  
  // Submit the form data using fetch
  fetch('/contact#contact_form', {
    method: 'POST',
    body: formData
  })
    .then(function(response) {
      console.log('response: ', response);
      if (response.ok) {
        // console.log('Form submitted successfully!');
        // Show success message
        document.querySelector('.footer-signup').classList.add('success');
        document.querySelector('.footer-signup .form-message--success').classList.remove('hidden');
        document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
        document.querySelector('.footer-signup form').classList.add('hidden');
        
      } else {
        console.log('Form submission failed.');
        // Show error message
        document.querySelector('.footer-signup .form-message--error').classList.remove('hidden');
      }
    })
    .catch(function(error) {
      // Show error message
      console.log('Error submitting form:', error);
      // console.log('error: ', error);
      document.querySelector('.footer-signup .form-message--error').classList.add('hidden');
    });
}

function grantTrackingConsent() {
    try {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
            window.Shopify.customerPrivacy.setTrackingConsent(
                { analytics: true, marketing: true, preferences: true, sale_of_data: true },
                function() {}
            );
        }
    } catch (error) {
        console.log('Error setting Shopify tracking consent:', error);
    }

    try {
        if (typeof window.fbq === 'function') {
            window.fbq('consent', 'grant');
        }
    } catch (error) {
        console.log('Error granting fbq consent:', error);
    }
}

function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
            return cookieValue;
        }
    }
    return null;
}

function setCookie(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function metaEventId() {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : 'ev_' + Date.now() + '_' + Math.random().toString(36).slice(2);
}

function metaTrack(eventName, params, eventId) {
    try {
        if (typeof window.fbq === 'function') {
            window.fbq('track', eventName, params || {}, { eventID: eventId || metaEventId() });
        }
    } catch (error) {
        console.log('Error sending Meta event:', eventName, error);
    }
}

document.addEventListener('click', function (e) {
    const link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.indexOf('wa.me') !== -1 || href.indexOf('whatsapp.com') !== -1) {
        metaTrack('Contact', { content_category: 'whatsapp' });
    } else if (href.indexOf('tel:') === 0) {
        metaTrack('Contact', { content_category: 'phone' });
    }
});

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get('customer_posted');

  if (contactPosted) {
    const successTag = document.querySelector('.footer-signup .form-message--success');
    const errorTag = document.querySelector('.footer-signup .form-message--error');
    if (contactPosted === 'true') {
      document.querySelector('.footer-signup')?.classList.add('success');
      if (successTag) {
        successTag.style.display = 'block';
      }
      if (errorTag) {
        errorTag.style.display = 'none';
      }
    } else {
      if (successTag) {
        successTag.style.display = 'none';
      }
      if (errorTag) {
        errorTag.style.display = 'block';
      }
    }

    setTimeout(() => {
      if (errorTag) {
        errorTag.style.display = 'none';
      }
      if (successTag) {
        successTag.style.display = 'none';
      }
    }, 3000);
  }
});


// footer subscribe form
const subscribeForm = document.getElementById('ContactFooter2');
// const recaptchaSiteKey = '6LfZ3-YlAAAAAH0pVfpyVNOGBTSvQy_1fA1AzVvB'; // v3
subscribeForm?.addEventListener('submit', function (event) {
  event.preventDefault();
  
  // grecaptcha.ready(function() {
  //   grecaptcha.execute('6LfZ3-YlAAAAAH0pVfpyVNOGBTSvQy_1fA1AzVvB', {action: 'submit'}).then(function(token) {
  //     onSubscribeFormSubmit();
  //   });
  // });
  onSubscribeFormSubmit();

  
  // Get a reCAPTCHA token to verify the user's identity
  // grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function(token) {
    // Set the token in the form data
    // document.querySelector('#g-recaptcha-response').value = token;
  
    
});


// function popupBodyOn() {
//   document.body.style.top = '-' + window.scrollY + 'px';
//   document.body.style.position = 'fixed';
// }

// function popupBodyOff() {
//   const scrollY = document.body.style.top;
//   document.body.style.position = '';
//   document.body.style.top = '';
//   window.scrollTo(0, parseInt(scrollY || '0') * -1);
// }